import { useEffect, useState } from "react";
import { Trophy, Users, Timer } from "lucide-react";
import { api } from "@/lib/api";
import { QUEST_ICON } from "@/lib/quest";
import { DoneStamp } from "@/components/quest/DoneStamp";

const date = (s) => new Date(s).toLocaleDateString("de-DE", { timeZone: "Europe/Berlin", day: "2-digit", month: "2-digit", year: "numeric" });
const dur = (h) => (h < 1 ? `${Math.max(1, Math.round(h * 60))} Min` : h < 48 ? `${String(h).replace(".", ",")} Std` : `${Math.round(h / 24)} Tagen`);

function GalleryCard({ q, i }) {
  return (
    <li className="relative rounded-3xl bg-gradient-to-br from-emerald-50 to-white border border-emerald-200 p-4 pt-5 overflow-hidden fade-up" style={{ animationDelay: `${i * 60}ms` }} data-testid={`quest-gallery-${q.id}`}>
      <span className="absolute right-2 top-4 scale-[0.5] origin-top-right"><DoneStamp testId={`quest-gallery-stamp-${q.id}`} /></span>
      <p className="font-display text-lg font-extrabold leading-tight pr-24">{q.title}</p>
      <p className="text-xs text-slate-500 mt-0.5">{date(q.start)} – {date(q.end)}</p>
      <p className="flex flex-wrap gap-x-3 gap-y-1 mt-2 text-xs font-bold text-emerald-800">
        {q.goals.map((g) => <span key={g.kind}>{QUEST_ICON[g.kind]} {g.count}/{g.goal} ✓</span>)}
      </p>
      <p className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-3 text-xs font-semibold text-slate-600">
        <span className="inline-flex items-center gap-1"><Users className="w-3.5 h-3.5" /> {q.participants} Mitmacher</span>
        {q.hours != null && <span className="inline-flex items-center gap-1" data-testid={`quest-gallery-hours-${q.id}`}><Timer className="w-3.5 h-3.5" /> in {dur(q.hours)} geschafft</span>}
        <span className="inline-flex items-center gap-1 text-emerald-700">+{q.stake} Punkte je Mitmacher</span>
      </p>
    </li>
  );
}

export function QuestGallery() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/quest/gallery").then(({ data }) => setList(data)).catch(() => setList([])); }, []);
  if (!list) return null;
  return (
    <section className="rounded-3xl bg-white border border-emerald-100 p-5 space-y-3" data-testid="quest-gallery">
      <p className="font-display text-xl font-extrabold flex items-center gap-2"><Trophy className="w-5 h-5 text-emerald-600" /> Erfolgs-Galerie <span className="ml-auto px-2.5 py-0.5 rounded-full bg-emerald-50 text-emerald-700 text-xs font-extrabold" data-testid="quest-gallery-count">{list.length} geschafft</span></p>
      {list.length ? (
        <ul className="grid sm:grid-cols-2 gap-3">{list.map((q, i) => <GalleryCard key={q.id} q={q} i={i} />)}</ul>
      ) : <p className="text-sm text-slate-400 text-center py-4" data-testid="quest-gallery-empty">Noch keine Aufgabe geschafft – die erste mit grünem Stempel landet hier!</p>}
    </section>
  );
}
